<template>
  <div style="height: 100%; width: 100%">

    <div v-if="!response" class="loading_page">
      <orbit-spinner :animation-duration="1000" :size="50" :color="'#0e96b1'" />
    </div>

    <div v-if="response" class="container-overlay">
      <div class="container custom-col-padding">
        <div class="row">
          <div class="col col-md-6">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">{{$t('Containers')}}</h5>
                <p style="font-size: 1.5rem" class="card-text text-primary text-bold">{{response.containersCount}}</p>
              </div>
            </div>
          </div>
          <div class="col col-md-6">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">{{$t('Served')}}</h5>
                <div class="row">
                  <div class="col-auto">
                    <p style="font-size: 1.5rem" class="card-text text-primary text-bold text-end">
                      {{response.containerServedCount}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col col-md-12">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">{{ $t('Date')}}</h5>
                <table v-if="response" class="table table-sm">
                  <tr>
                    <td class="text-center text-primary">{{ $router.currentRoute.params.from}}</td>
                    <td class="text-center text-primary">{{ $router.currentRoute.params.to}}</td>
                  </tr>
                  <tr>
                    <td class="text-center text-primary">{{ $t('distance')}}</td>
                    <td class="text-center text-primary">{{response.totalDistance}} km</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <div class="col col-md-12">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">{{ $t('Device')}}</h5>
                <table v-if="response" class="table table-sm">
                  <tr><td colspan="2" class="text-center text-primary">{{ response.device}}</td></tr>
                  <tr><td colspan="2" class="text-center text-primary">{{response.owner}}</td></tr>
                  <tr><td colspan="2" class="text-center text-primary">{{response.contract}}</td></tr>
                </table>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div id="mapObj" ref="mapElement" style="height: 100vh; width: 100%;"></div>
  </div>
</template>

<script>

import { ref, onMounted, onBeforeUnmount, h } from '@vue/composition-api'
import L from 'leaflet';
import 'leaflet/dist/leaflet.css'
import 'leaflet-polylinedecorator'
import router from '@/router'
import axios from '@/libs/axios'
import {BCollapse, BCard, BButton, BTable, BTr, BTd, BTableSimple, BRow, BCol} from 'bootstrap-vue'
import PointPopup from '@/views/maps/PointPopup.vue'
import ContainerPopup from '@/views/maps/ContainerPopup.vue'
import {intPopup, initMarker } from '@/ext/route.utilities'
import { OrbitSpinner } from 'epic-spinners'



export default {
  components: {
    BCollapse,BCard,BButton,
    BTable, BTr, BTd, BTableSimple, OrbitSpinner
  },

  setup() {

    const options = {  weight: 4, fillColor: 'red', fillOpacity: 0.3, opacity: 1, color: 'black'}
    const mapElement = ref(null)
    let map = null

    const response = ref(null)

    document.getElementsByTagName('html')[0].dir = "ltr"

    onMounted(async ()  => {

      map = L.map(mapElement.value, {center: [24.1307751,39.7842496], zoom: 6 })
      const googleStreets = L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',{ maxZoom: 20, subdomains:['mt0','mt1','mt2','mt3'] }).addTo(map);
      const googleHybrid = L.tileLayer('https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',{ maxZoom: 20, subdomains:['mt0','mt1','mt2','mt3'] })
      L.control.layers({googleStreets, googleHybrid}, {},{
        position: 'topleft'}).addTo(map)

      axios.get('maps/getRfidRoute', { params: {
          device: router.currentRoute.params.id, from: router.currentRoute.params.from,
          to: router.currentRoute.params.to, }}).then(async res => {

        response.value = res.data

        if (res.data.points.length < 1) return

        if (res.data.workArea)
        {
          const polygonPoints = res.data.workArea.split('((')[1].slice(0, -2).split(', ')
          const P = L.polygon(polygonPoints.map((v, i) => [parseFloat(v.split(' ')[0]), parseFloat(v.split(' ')[1])]),
              options).addTo(map)
          setTimeout( () => map.fitBounds(P.getBounds()), 1000);
        }

        const latLngArray = res.data.points.map(item =>
            [item.latitude, item.longitude])

        const pin = require('@/assets/icons/pin.png')
        const startPoint = initMarker(pin, res.data.points[0]).addTo(map).bindPopup(intPopup(PointPopup, res.data.points[0]))
        const endPoint = initMarker(pin, res.data.points[res.data.points.length -1]).addTo(map).bindPopup(
            intPopup(PointPopup, res.data.points[res.data.points.length -1]))

        // route
        const polyline = L.polyline(latLngArray, { color: '#341f97' }).addTo(map)
          L.polylineDecorator(polyline, {
            patterns: [{ offset: '50%', repeat: 200,
                symbol: L.Symbol.arrowHead({ pixelSize: 5, pathOptions: { stroke: true, color: 'red' } })
              }] }).addTo(map)


        // route points
        for (const i in res.data.points)
        {
          const latlng = [res.data.points[i].latitude, res.data.points[i].longitude]
          let color = getColor(res.data.points[i].status)
          const circle = L.circle(latlng, { color: color, fillColor: color, fillOpacity: 1,
            radius: 2 }).addTo(map).bindPopup(intPopup(PointPopup, res.data.points[i]))
        }


        let planTags = [];
        let planTagsPoint = [];

        // plan containers
        if (res.data.planContainers.length > 1) {

          for (const i in res.data.planContainers)
          {
            if (res.data.planContainers[i].latitude && res.data.planContainers[i].longitude)
            {
              const latlng = [res.data.planContainers[i].latitude, res.data.planContainers[i].longitude]
              const circle = L.circle(latlng, {
                color: '#e056fd', fillColor: '#e056fd', fillOpacity: 0.6, radius: 15
              }).addTo(map).bindPopup(intPopup(ContainerPopup, res.data.planContainers[i]))

              planTags[res.data.planContainers[i].tag] = circle
              planTagsPoint[res.data.planContainers[i].tag] = latlng
            }
          }
        }


        // actually left
        for (const i in res.data.rfidEvents)
        {
          const latlng = [res.data.rfidEvents[i].latitude, res.data.rfidEvents[i].longitude]
          const circle = L.circle(latlng, {
            color: 'orange', fillColor: 'orange', fillOpacity: 0.6, radius: 15
          }).addTo(map).bindPopup(intPopup(ContainerPopup, res.data.rfidEvents[i]))

          circle.on('click', function (e) {

            if (planTags[res.data.rfidEvents[i].tag]) {

              planTags[res.data.rfidEvents[i].tag].
              setStyle({ color: 'blue', fillColor: 'lightblue' });

              const dashedLine = L.polyline([
                  [res.data.rfidEvents[i].latitude, res.data.rfidEvents[i].longitude],
                planTagsPoint[res.data.rfidEvents[i].tag]
              ], { color: 'red', dashArray: '10, 5' }).addTo(map)

              console.log('plans', planTagsPoint[res.data.rfidEvents[i].tag])
              console.log('actually', [res.data.rfidEvents[i].latitude, res.data.rfidEvents[i].longitude])

            }
          })

        }

      })

    })

    const getColor = status => {
      switch(status) {
        case 'moving': return '#16a085'
        case 'stop': return '#e74c3c'
        case 'ignitionOff': return '#2c3e50'
        default: return '#2c3e50'
      }
    }


    onBeforeUnmount(() => {
      map.remove()
    })

    return {
      mapElement,
      response
    }
  }
}


</script>

<style lang="less">

.container-overlay {
  position: absolute;
  top: 20px;
  right: 0;
  width: 20%;
  z-index: 99999;
}

.custom-col-padding .col {
  padding: 0.3rem;
}

.leaflet-popup-close-button {
  display: none !important;
}

.leaflet-popup-content-wrapper {
  background: transparent;
  box-shadow: none;
  border-radius: 0;

}

.card {
  margin-bottom: 0 !important;
}

.leaflet-marker-icon {
  background: transparent !important;
  border: none;
}

</style>